import { Languages } from '@/constants'
import { useStore } from '@/containers'
import type { Product } from '@/types'
import type { Dispatch, SetStateAction } from 'react'
import { useEffect, useState } from 'react'
import BundledProductCard from './BundledProductCard'
export interface BundledProductProps {
  bundledProducts: Product[]
  listBundleSelected: Product[]
  setListBundleSelected: Dispatch<SetStateAction<Product[]>>
  priceWithService: number
}
const BundledProduct = ({
  bundledProducts,
  listBundleSelected,
  priceWithService,
  setListBundleSelected,
}: BundledProductProps) => {
  const { selectedLang } = useStore()
  const [addToListBundle, setAddToListBundle] = useState<string[]>([])
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'VND'
      default:
        return 'VND'
    }
  }
  const filterArrayByStringArray = (
    originalArray: Product[],
    arrayString: string[]
  ): Product[] => {
    return originalArray.filter(item => arrayString.includes(item._id))
  }
  useEffect(() => {
    if (addToListBundle) {
      const filteredArray = filterArrayByStringArray(
        bundledProducts,
        addToListBundle
      )
      setListBundleSelected(filteredArray)
    }
  }, [addToListBundle])
  const mediaPrice = listBundleSelected.reduce((sum, item) => {
    if (typeof item.price === 'number' && !isNaN(item.price)) {
      return sum + item.price
    } else {
      return sum
    }
  }, 0)
  const totalPrice = listBundleSelected.reduce((sum, product) => {
    if (typeof product?.salePrice === 'number' && !isNaN(product?.salePrice)) {
      return sum + product?.salePrice
    } else {
      return sum
    }
  }, 0)
  const savePrice = mediaPrice - totalPrice

  return (
    <div className='suggestedProduct w-full bg-amber-50 px-2 pt-4 pb-2 border-b-8 border-gray-200'>
      <h3 className='mb-2 w-full text-base font-bold leading-normal text-gray-800'>
        Gợi ý mua kèm
      </h3>
      <div className='flex w-full flex-wrap'>
        <div className='listProduct w-full'>
          <div className='flex flex-wrap w-full gap-2'>
            {bundledProducts &&
              bundledProducts?.map((e: Product, idx: number) => {
                return (
                  <div className='item w-full' key={idx}>
                    <BundledProductCard
                      item={e}
                      setAddToListBundle={setAddToListBundle}
                      addToListBundle={addToListBundle}
                    />
                  </div>
                )
              })}
          </div>
        </div>
        {addToListBundle && addToListBundle?.length > 0 && (
          <div className='price w-full'>
            <div className='action mt-5 flex flex-wrap'>
              <ul className='list w-full gap-4'>
                <li className='item flex items-center mb-1'>
                  <div className='left max-w-[100px] flex-[0_0_100px]'>
                    <p className='text-sm font-normal text-gray-800'>
                      Tiết kiệm:
                    </p>
                  </div>
                  <div className='right flex-1 text-right'>
                    <p className='text-right text-sm font-bold text-gray-800'>
                      -
                      {savePrice
                        .toLocaleString(Languages.VN, {
                          style: 'currency',
                          currency: currency(selectedLang as string),
                        })
                        .replace(/\s₫/g, 'đ')}
                    </p>
                  </div>
                </li>
                <li className='item flex items-center gap-2 mb-1'>
                  <div className='left max-w-[100px] flex-[0_0_100px]'>
                    <p className='text-sm font-normal text-gray-800'>
                      Tổng tiền:
                    </p>
                  </div>
                  <div className='right flex-1 text-right'>
                    <p className='text-right text-lg font-extrabold text-primary-second'>
                      {(totalPrice + priceWithService)
                        .toLocaleString(Languages.VN, {
                          style: 'currency',
                          currency: currency(selectedLang as string),
                        })
                        .replace(/\s₫/g, 'đ')}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default BundledProduct
